const userPromptMessages = {
  'userPrompt.report.header': '報告書削除',
  'userPrompt.message.delete': '本当に削除しますか？',
  'userPrompt.message.dataDelete': '本当にデータを削除しますか？',
  'userPrompt.message.dataRestore': '本当にデータを復元しますか？',
  'userPrompt.message.dataCompleteDelete.1': '本当にデータを削除しますか？',
  'userPrompt.message.dataCompleteDelete.2':
    '※一度削除されたデータは元に戻せません。',
  'userPrompt.message.otherError': '処理に失敗しました',
  'userPrompt.message.serverError': '一時的にサーバーからの応答がありません。',
  'userPrompt.message.status400': '不正なリクエストです',
  'userPrompt.message.status401':
    'セッションの有効期限が切れました。ログインしてください',
  'userPrompt.message.status404': 'リソースが見つかりません',
  'userPrompt.message.status500': 'サーバーリクエストに失敗しました。',
  'userPrompt.message.ownUpdate': 'ログインスタッフ自身の情報は編集できません',
  'userPrompt.message.successImport': 'インポート完了',
  'userPrompt.message.failureImport': 'インポート失敗',
  'userPrompt.message.tags.status409.1': 'タグの編集が競合しました。',
  'userPrompt.message.tags.status409.2':
    'お手数ですが、最初からやり直してください。',
  'userPrompt.message.trash.status409.1':
    'ストレージが一杯のため、復元に失敗しました。',
  'userPrompt.message.trash.status409.2':
    'ストレージを確保した上でもう一度操作してください。',
  'userPrompt.message.noGroupUser.1':
    '表示中の作業者は選択したグループに参加していません。',
  'userPrompt.message.noGroupUser.2': 'ダッシュボードに遷移します。',
  'userPrompt.message.staff.sync.authority':
    '全作業者の権限同期を実行します。よろしいですか？',
  'userPrompt.message.report.delete':
    '報告書を削除しますが、宜しいでしょうか？',
  'userPrompt.message.group.noCorporateAdmin':
    '管理者を1人以上登録する必要があります。',
  'userPrompt.message.reportEdit.frameLimit':
    '選択できる写真の上限は100件です。',
  'userPrompt.message.deviceAuth.setting.error':
    'メール送信先を1人以上登録する必要があります。',
  'userPrompt.button.noDelete': '削除しない',
  'userPrompt.button.delete': '削除',
  'userPrompt.button.noRestore': '復元しない',
  'userPrompt.button.restore': '復元',
  'userPrompt.button.close': '閉じる',
  'userPrompt.button.ok': 'OK',
  'userPrompt.button.cancel': 'キャンセル',
  'userPrompt.button.retry': '再試行する',
  'userPrompt.button.reconnect': '再呼出',
};

export default userPromptMessages;
